import { useEffect, useRef } from 'react';

export const GET_SUGGESTION_SHORTCUT_LABEL = 'Alt+Shift+G';

// Matched on `code`, not `key`: on a Mac, Option+Shift+G produces "˝" as the key.
export const isGetSuggestionShortcut = (event: KeyboardEvent): boolean =>
	event.code === 'KeyG' && event.altKey && event.shiftKey && !event.ctrlKey && !event.metaKey;

/**
 * Runs `onShortcut` on Alt+Shift+G from anywhere on the page, for a one-button macro pad at the rep's
 * desk. Listens in the capture phase so a focused input can't swallow it, and ignores auto-repeat so
 * holding the key sends one request.
 */
export function useGetSuggestionShortcut(onShortcut: () => void): void {
	const onShortcutRef = useRef(onShortcut);
	onShortcutRef.current = onShortcut;

	useEffect(() => {
		const handleKeyDown = (event: KeyboardEvent) => {
			if (!isGetSuggestionShortcut(event)) return;
			event.preventDefault();
			if (event.repeat) return;
			onShortcutRef.current();
		};
		document.addEventListener('keydown', handleKeyDown, true);
		return () => document.removeEventListener('keydown', handleKeyDown, true);
	}, []);
}
